module.exports = __webpack_public_path__ + "media/images/shield-b09961a0.png";